import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { ExternalProviderRepository } from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface UploadSpeakerResumeCommand {
  file: File;
  externalProviderRepository: ExternalProviderRepository;
}

export const uploadSpeakerResume = createApiThunk<string, UploadSpeakerResumeCommand>(
  "externalProvider/uploadSpeakerResume",
  async ({ file, externalProviderRepository }: UploadSpeakerResumeCommand) => {
    return externalProviderRepository.uploadSpeakerResume(file);
  },
);

export const resetUploadSpeakerResume = createAction("externalProvider/resetUploadSpeakerResume");
